'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('stationaccess', {
      url: '/account/stationaccess?jurisdiction&sta_recid',
      template: '<stationaccess></stationaccess>',
      authenticate: true,
      params: {
        jurisdiction: null,  // Default value if not provided
        sta_recid: null      // Default value if not provided
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/stationaccess/stationaccess.routes.js